import { render, staticRenderFns } from "./accommodation.vue?vue&type=template&id=6b3e5d6c&scoped=true&"
import script from "./accommodation.vue?vue&type=script&lang=js&"
export * from "./accommodation.vue?vue&type=script&lang=js&"
import style0 from "./accommodation.vue?vue&type=style&index=0&id=6b3e5d6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e5d6c",
  null
  
)

export default component.exports